const question = { name: "question", label: "Question", review: false };
const answers = {
  name: "answers",
  label: "Answers",
  isList: true,
  displayFilters: [
    { cardType: "q_matrix", field: "matrix_type", value: ["single", "multiple"] },
  ],
};
const buttons = {
  name: "buttons",
  label: "Buttons",
  isList: true,
  displayFilters: [{ field: "add_btn", value: true }],
};
const quickReplies = {
  name: "quick_replies",
  label: "Quick Replies",
  isList: true,
  displayFilters: [{ field: "add_qr", value: true }],
};
const images = { name: "images", label: "Images", isList: true, alias: "answers", acceptedType: "image" };
const items = { name: "items", label: "Items", isList: true };
const text = { name: "text", label: "Text", review: false };
const startButton = { name: "start_button", label: "Start button", review: false };
const emoji = { name: "emoji", label: "Emoji", review: false };
const consent = {
  name: "consent",
  label: "Privacy consent",
  review: false,
  displayFilters: [{ field: "consent_mode", value: "custom" }],
};
const url = { name: "url", label: "URL" };
const loop = { name: "loop", label: "Loop" };
const q_hidden = { name: "q_hidden", label: "Recode", isList: false };
const optionalQuestion = { ...question, optional: true };
const prompt_d = { name: "prompt", label: "Context", desc: true, accordion: "context", is_accordion_open: true };
const prompt_details = {
  name: "prompt_details",
  label: "Detailed Objectives",
  desc: true,
  accordion: "objectives",
};
const interview_guide = {
  name: "interview_guide",
  label: "Interview Guide",
  desc: true,
  accordion: "interview-guide",
};
const interview_guidelines = {
  name: "interview_guidelines",
  label: "Interview guidelines (Optional)",
  desc: true,
  accordion: "guidelines",
};
const mission = { name: "mission", label: "Respondent mission" };
const assistant_role = { name: "assistant_role", label: "Assistant role", optional: true };
const opening_message = { name: "opening_message", label: "Opening instruction", optional: true };
const quota_type = { name: "quota_type", label: "Type", default: "hard" };
const customize_quota_message = {
  name: "customize_quota_message",
  default: false,
  review: false,
  displayFilters: [{ field: "quota_type", value: "hard" }],
};
const quota_message = {
  name: "quota_message",
  default: {},
  displayFilters: [{ field: "customize_quota_message", value: true }],
};
export default {
  q_single: [question, answers],
  q_multiple: [question, answers],
  q_ranking: [question, answers],
  q_open: [question],
  q_open_multiple: [question],
  q_matrix: [question, items, answers],
  q_numeric: [question],
  q_zipcode: [question],
  q_city: [question],
  q_email: [question],
  q_image: [question],
  q_video: [question],
  q_audio: [question],
  q_rating: [question],
  q_slider: [question],
  q_language: [question],
  q_image_choice: [question, images],
  q_image_choice_multiple: [question, images],
  q_hidden: [optionalQuestion, q_hidden],
  m_start: [emoji, text, startButton, consent],
  m_text: [text, quickReplies, buttons],
  m_image: [{ name: "medium", label: "Medium", acceptedType: "image" }, quickReplies],
  m_video: [{ name: "medium", label: "Medium", acceptedType: "video" }, quickReplies],
  m_audio: [{ name: "medium", label: "Medium", acceptedType: "audio" }, quickReplies],
  m_gallery: [{ name: "media", label: "Images", acceptedType: "image", alias: "images", isList: true }, quickReplies],
  m_thanks: [text, quickReplies],
  o_redirect: [{ name: "redirects", label: "Rules", isList: true }],
  o_typing: [],
  o_pause: [],
  o_user_attributes: [
    { name: "attribute_name", label: "Attribute name" },
    { name: "attribute_values", label: "Value", isList: true },
  ],
  o_reward: [{ name: "amounts", label: "Amount", isList: true }],
  o_conversion: [],
  o_url_redirect: [url],
  o_ab: [
    { name: "description", label: "Description", review: false },
    { name: "populations", label: "Populations", isList: true },
  ],
  o_cells: [{ name: "cells", label: "Cells", isList: true }],
  o_loop: [loop],
  o_random_blocks: [{ name: "random_blocks", label: "Random blocks" }],
  o_custom: [{ name: "custom", label: "Custom" }],
  o_quota: [quota_type, customize_quota_message, quota_message],
  ai_chat: [{ name: "question", label: "Prompt", alias: "question", desc: false }],
  ai_chat_v2: [prompt_d, prompt_details, interview_guide, interview_guidelines],
  q_llm_conversation: [mission, assistant_role, opening_message],
  q_nps: [question],
};
